import { Notification } from 'grommet';
import type { DisclaimerProps } from '@customTypes/types';

export const Disclaimer = (props: DisclaimerProps): JSX.Element => {
  return (
    <Notification
      status="info"
      message={props.text}
      global
    />
  );
};
